export default "<div class=\"graph-wrapper\">\n    <canvas id=\"graph\" (click)=\"clickHandler($event)\"></canvas>\n</div>";